<!--component html goes here -->
<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="container-fluid bg-light" style="min-height: 800px;">
  <div class="responsive-tabs">
    <ul class="nav nav-tabs mb-3 companyNav">
      <li class="nav-item">
        <a class="nav-link text-dark" [routerLinkActive]="['active']" [routerLink]="['events']"><i class="fas fa-calendar-alt"></i> Events</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-dark" [routerLinkActive]="['active']" [routerLink]="['courses']"><i class="fad fa-film"></i> On-Demand</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-dark" [routerLinkActive]="['active']" [routerLink]="['users']"><i class="fas fa-users"></i> Users</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-dark" [routerLinkActive]="['active']" [routerLink]="['organizations']"><i class="fas fa-building"></i> Organizations</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-dark" [routerLinkActive]="['active']" [routerLink]="['sponsor-organizations']"><i class="fas fa-booth-curtain"></i> Sponsor Orgs</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-dark" [routerLinkActive]="['active']" [routerLink]="['conferences']"><i class="fad fa-handshake"></i> Conferences</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-dark" [routerLinkActive]="['active']" [routerLink]="['purchase-orders']"><i class="fas fa-sack-dollar"></i> Purchase Orders</a>
      </li>
    </ul>
    <router-outlet></router-outlet>
  </div>
</div>
